import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9 } from "styled-components";
import * as RadixAccordion from "@radix-ui/react-accordion";
import { Icon } from "~/features/ui/icon";
import { type AccordionItem } from "~/features/product-configurator/configurator-types";
import CaretDown from "~/public/icons/caret-down.svg";
type Props = {
  items: AccordionItem[];
  value: string;
  onValueChange: (value: string) => void;
};
export function ConfiguratorOthersAccordion({
  items,
  value,
  onValueChange
}: Props) {
  return <_StyledDiv>
      <_StyledH>
        Others
      </_StyledH>

      <RadixAccordion.Root type="single" collapsible value={value} onValueChange={onValueChange}>
        {items.map(item => <_StyledRadixAccordionItem key={item.id} value={item.id}>
            <RadixAccordion.Header>
              <_StyledRadixAccordionTrigger aria-label={item.title}>
                <_StyledSpan>{item.title}</_StyledSpan>
                <_StyledIcon icon={CaretDown} size="16" $_css={[{
              "transitionProperty": "transform",
              "transitionDuration": "250ms",
              "transitionTimingFunction": "ease-in-out"
            }, value === item.id && {
              "--tw-rotate": "180deg",
              "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
            }]} />
              </_StyledRadixAccordionTrigger>
            </RadixAccordion.Header>
            <_StyledRadixAccordionContent $_css2={[{
          "overflow": "hidden"
        }, {
          "@keyframes radix-accordion-expand-keyframes": {
            "from": {
              "height": "0"
            },
            "to": {
              "height": "var(--radix-accordion-content-height)"
            }
          },
          "&[data-state=\"open\"]": {
            "animation": "radix-accordion-expand-keyframes 250ms ease-in-out"
          }
        }, {
          "@keyframes radix-accordion-collapse-keyframes": {
            "from": {
              "height": "var(--radix-accordion-content-height)"
            },
            "to": {
              "height": "0"
            }
          },
          "&[data-state=\"closed\"]": {
            "animation": "radix-accordion-collapse-keyframes 250ms ease-in-out"
          }
        }]}>
              <_StyledDiv2>
                <_StyledP>Content coming soon.</_StyledP>
              </_StyledDiv2>
            </_StyledRadixAccordionContent>
          </_StyledRadixAccordionItem>)}
      </RadixAccordion.Root>
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-1lpfgnm-0"
})({
  "paddingTop": "var(--spacing-2xl)"
});
var _StyledH = _styled2("h3").withConfig({
  componentId: "sc-sf-1lpfgnm-1"
})({
  "borderBottomWidth": "1px",
  "borderColor": "var(--stroke-primary)",
  "paddingTop": "var(--spacing-md)",
  "paddingBottom": "var(--spacing-md)",
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "500",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "500"
  }
});
var _StyledRadixAccordionItem = _styled3(RadixAccordion.Item).withConfig({
  componentId: "sc-sf-1lpfgnm-2"
})({
  "borderBottomWidth": "1px",
  "borderColor": "var(--stroke-primary)"
});
var _StyledRadixAccordionTrigger = _styled4(RadixAccordion.Trigger).withConfig({
  componentId: "sc-sf-1lpfgnm-3"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingTop": "var(--spacing-md)",
  "paddingBottom": "var(--spacing-md)",
  "textAlign": "left"
});
var _StyledSpan = _styled5("span").withConfig({
  componentId: "sc-sf-1lpfgnm-4"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});
var _StyledIcon = _styled6(Icon).withConfig({
  componentId: "sc-sf-1lpfgnm-5"
})`${p => p.$_css}`;
var _StyledRadixAccordionContent = _styled7(RadixAccordion.Content).withConfig({
  componentId: "sc-sf-1lpfgnm-6"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled8("div").withConfig({
  componentId: "sc-sf-1lpfgnm-7"
})({
  "paddingBottom": "var(--spacing-lg)"
});
var _StyledP = /*#__PURE__*/_styled9("p").withConfig({
  displayName: "configurator-others-accordion___StyledP",
  componentId: "sc-1tapz1u-0"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "color": "var(--text-transparent)"
});